import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenu, IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageRe0023 extends IComponentController {
    menuBandeau: IMenu;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    rteMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rteMultiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Re0023Controller(Menu: IMenuClass, ecranDetails: IEcranDetailsResourcesEntite, Formulaire: IFormulaireClass, FormulaireItem: IFormulaireItemClass) {
    const vm: IPageRe0023 = this;
    vm.$onInit = $onInit;
    function $onInit() {
        vm.menuBandeau = new Menu([]);
        vm.valeursEcran = ecranDetails.valeurs;
        vm.rteMultiOccurrenceOptions = {
            bloc: 'rte',
            fonctions: {
                importation: true
            },
            colonnesVisibles: [
                { nom: 'tagcodori', largeur: 120 },
                { nom: 'tagdscabrori', largeur: 280 },
                { nom: 'tagcodret', largeur: 120 },
                { nom: 'tagdscabrret', largeur: 280 }
            ],
            formulaire: new Formulaire([new FormulaireItem('tagcleintori'), new FormulaireItem('tagcleintret')])
        };
    }
}
